<template>
    <rkm-overlay>
        <template v-if="centroCusto.setor.tipoId === enums.setorTipo.RECEPCAO">
            <rkm-layout-body title="Recepção">
                <template v-slot:actions>
                    <rkm-button
                        @click="$refs.ModalAgendamento.open()"
                        color="primary"
                    >
                        Agendamentos
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalAtendimento.open()"
                        color="primary"
                    >
                        Atendimentos
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalEvasao.open()"
                        color="primary"
                    >
                        Atendidos/Evadidos
                    </rkm-button>

                    <rkm-button
                        @click="$router.push({name: 'ambulatorio-recepcao-create'})"
                        authorize="store-ambulatorio-recepcao"
                        color="primary"
                    >
                        Adicionar paciente na lista
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <List />
                </rkm-layout-content>

                <ModalAgendamento ref="ModalAgendamento" />
                <ModalAtendimento ref="ModalAtendimento" />
                <ModalEvasao ref="ModalEvasao" />
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Recepção">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>RECEPÇÃO</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/recepcao/List'
import ModalAgendamento from '@/components/ambulatorio/gerenciamento-diario/components/agendamento/Modal'
import ModalAtendimento from '@/components/ambulatorio/gerenciamento-diario/components/atendimento/Modal'
import ModalEvasao from '@/components/ambulatorio/gerenciamento-diario/components/evasao/Modal'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {
        List,
        ModalAgendamento,
        ModalAtendimento,
        ModalEvasao,
    },
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
    },
    data: () => ({
        enums: {setorTipo},
    }),
}
</script>